export var isIE = true && !!window.document["documentMode"] || false;